import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: 'img[appImageFallback]',
    standalone: true
})
export class ImageFallbackDirective {
    @Input() appImageFallback: string = '/assets/images/placeholder/product.png';

    constructor(private el: ElementRef) { }

    @HostListener('error')
    onError() {
        const element: HTMLImageElement = this.el.nativeElement;
        console.log('Image load error detected for:', element.src);

        // Use a custom attribute to prevent infinite loops if the fallback also fails
        if (!element.getAttribute('data-fallback-tried')) {
            console.log('Setting fallback image:', this.appImageFallback);
            element.setAttribute('data-fallback-tried', 'true');
            element.src = this.appImageFallback;
        } else {
            console.warn('Fallback image also failed to load or already tried.');
        }
    }
}
